import moment from "moment-timezone";
import { GENERAL } from "@/constants";
import { DateInput, Nullable } from "@/types";

export const formatTime = (
  dateString: string | undefined,
  timezone?: string
): string => {
  if (!dateString) return "";
  try {
    const date = moment.utc(dateString);

    if (timezone) {
      if (moment.tz.zone(timezone)) {
        date.tz(timezone);
      } else if (timezone.startsWith("GMT")) {
        const offsetMatch = timezone.match(/GMT([+-])(\d+)/);
        if (offsetMatch) {
          const sign = offsetMatch[1] === "+" ? 1 : -1;
          const hours = parseInt(offsetMatch[2], 10);
          const offsetMinutes = sign * hours * 60;
          date.utcOffset(offsetMinutes);
        }
      } else {
        const offsetMatch = timezone.match(/([+-])(\d+)(?::(\d+))?/);
        if (offsetMatch) {
          const sign = offsetMatch[1] === "+" ? 1 : -1;
          const hours = parseInt(offsetMatch[2], 10);
          const minutes = offsetMatch[3] ? parseInt(offsetMatch[3], 10) : 0;
          const offsetMinutes = sign * (hours * 60 + minutes);
          date.utcOffset(offsetMinutes);
        }
      }
    }

    return date.format("HH:mm");
  } catch (error) {
    return dateString;
  }
};

export default function DateHelper() {
  function formatDate(date: DateInput, format?: Nullable<string>) {
    return date ? moment(date).format(format ?? GENERAL.TIME_FORMAT) : "";
  }

  function formatDateUTC(date: DateInput, format?: Nullable<string>) {
    return date
      ? moment
          .utc(date)
          .local()
          .format(format ?? GENERAL.TIME_FORMAT)
      : "";
  }

  function getTimeOnly(date: DateInput) {
    return date ? moment(date).format(GENERAL.TIME_ONLY_FORMAT) : "";
  }

  function getTodayDate() {
    const date = new Date();
    return date ? moment(date).format(GENERAL.DATE_FORMAT) : "";
  }

  function getDateFromUnix(timestemp: Nullable<number>) {
    return timestemp
      ? moment.utc(timestemp * 1000).format(GENERAL.DATE_FORMAT)
      : "";
  }

  return {
    formatDate,
    formatDateUTC,
    getTimeOnly,
    getTodayDate,
    getDateFromUnix,
  };
}
